import { render, staticRenderFns } from "./AlarmCategoryMessageSelect.vue?vue&type=template&id=132135f0"
import script from "./AlarmCategoryMessageSelect.vue?vue&type=script&lang=js"
export * from "./AlarmCategoryMessageSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports